import { ExclusionListData } from '../../exclusionListSelector/types';

export interface NewExclusionListWebComponentSchema {
  // all the data needed for rendering
  response: any;
  success: boolean;
}

export enum NewExclusionListEvents {
  SET_LIST_ID = 'setListId',
}

export enum NewExclusionErrors {
  DUPLICATE = 'already exists',
  INVALID = 'wrong format',
  UNKNOWN = '',
}

export enum NewExclusionErrorMsg {
  DUPLICATE = 'An exclusion list with the same name already exists.',
  INVALID = 'Invalid exclusion. Please update and try again.',
  UNKNOWN = 'An error has occurred while saving. Please try again.',
}

export enum RpcExclusionListsMethod {
  CREATE_RECORDS = "createRecords",
  UPDATE_RECORDS = "updateRecords",
  GET_LIST_INFO = "getListInfo",
}

export enum RpcExclusionItemsMethod {
  CREATE_RECORDS = "createRecords",
  UPDATE_RECORDS = "updateRecords",
  READ_RECORDS = "readRecords",
}

export enum RpcExclusionItemToListMappingsMethod {
  ASSIGN_MULTIPLE_ITEMS_TO_LIST = "assignMultipleItemsToList",
}

export enum RpcUtilsMethod {
  CONVERT_CSV_TO_JSON = "convertCsvToJson",
}

export enum RpcAction {
  EXCLUSION_ITEMS = "ExclusionItems",
  EXCLUSION_LISTS = "ExclusionLists",
  EXCLUSION_ITEM_TO_LIST = "ExclusionItemToListMappings",
  UTILS = "Utils",
}

export enum ExclusionItemFormEvents {
  CREATE_NEW_EXCLUSION_ITEM = 'createNewExclusionItem',
  CHANGE_OBJECT_TYPE = 'changeObjectType',
}

export interface ExclusionItemsResponse {
  data: Array<ExclusionListData>;
  success: boolean;
}
